module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "mainHead"
  }, [_c('el-col', {
    staticStyle: {
      "textAlign": "right"
    }
  }, [_c('div', {
    staticClass: "newAdd"
  }, [_vm._t("default")], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-727f7ea5"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/mainHead/mainHead.vue
// module id = 618
// module chunks = 70